// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"style_loaderWrapper__XIHpM"};